export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Hrvatski'
  },
  'title': 'POVLAČENJE PROIZVODA QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Opoziv proizvoda. Važne informacije o vašoj sigurnosti i opremi.',
    'purchaseWindow': 'Kupili ste penjački komplet (sistem) ALPINISM i/ili VERTIKA između 1. siječnja 2022. i 23. srpnja 2026. godine.',
    'skus': 'Penjački komplet Alpinism 11 cm (4051175 / 8589547)\nPenjački komplet Alpinism 17 cm (4051176 / 8589548)\nPakiranje od 5 penjačkih kompleta Alpinism (4171656 / 8608405)\nPenjački komplet Vertika 11 cm (5499689 / 8935765)\nPenjački komplet Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Dizajniranje osobne zaštitne opreme podrazumijeva apsolutnu odgovornost prema onima koji koriste naše proizvode. Stoga vas obavještavamo o opozivu penjačkih kompleta opremljenih karabinerom Rocky Fil.',
    'defect': 'Uočili smo nedostatak u zakivanju žičanih vrata na pojedinim karabinerima. Ovaj nedostatak pri sastavljanju može uzrokovati pucanje žičanih vrata i stvoriti rizik od lomljenja karabinera u slučaju pada.',
    'stopUsing': 'Iz opreza vas molimo da odmah prestanete koristiti svoj proizvod i slijedite postupak u nastavku.'
  },
  'procedure': {
    'stopUsing': 'Stoga vas molimo da odmah prestanete koristiti ovu opremu i provjerite je li vaš proizvod zahvaćen ovim nedostatkom pomoću uputa za rješavanje problema u nastavku.',
    'title': 'Provjerite svoje proizvode:',
    'intro': 'Provjerite jesu li obje strane žičanih vrata i dalje čvrsto pričvršćene za karabiner:',
    'step1': 'Uhvatite karabiner s jedne strane, stavite palac između dvije žice (palac najbliže zakovici). Čvrsto pritisnite prema dolje prema karabineru.',
    'step2': 'Okrenite karabiner i ponovite istu radnju na drugoj strani žičanih vrata.'
  },
  'outcome': {
    'nok': {
      'body': 'Nakon pregleda, žica se olabavila: Molimo vas da odmah prestanete koristiti svoj proizvod i vratite ga u najbližu DECATHLON trgovinu. Naš tim preuzet će vaš neispravan proizvod i odmah izvršiti puni povrat novca za ove opozvane artikle.',
      'support': 'Ako imate specifičnu situaciju, naš tim službe za korisnike stoji vam na raspolaganju kako bi pronašao prilagođeno rješenje i vodio vas kroz svaki korak:\nOd ponedjeljka do petka: 9:00 - 18:00 Subota: 9:00 - 17:00 +385 0800 8801'
    },
    'ok': {
      'body': 'Nakon provjere, žica ne izlazi iz svog kućišta: Vaš proizvod nije zahvaćen ovim nedostatkom te ga možete nastaviti koristiti.'
    }
  },
  'buttons': {
    'ok': 'Moj proizvod je u redu',
    'nok': 'Moj proizvod nije u redu.'
  }
} as const
